import React from 'react'
import { scalePoint } from '@vx/scale'

import { CONST } from './models/sankey-layout.model'
import { Axes } from '../../common/axes/axes'

export const Axis = function ({ sankeyData }) {
  const stageLabels = sankeyData.layout.stageLabels
  const xAxisTopPosition = sankeyData.layout.sankeyChartHeight - CONST.AXIS_HEIGHT
  const halfOfSegWidth = CONST.SEGMENT_WIDTH / 2

  return (
    <Axes
      options={{ hideAxisLeft: true }}
      scales={{
        x: scalePoint({
          domain: stageLabels.map((value, index) => (index)),
          padding: 0,
          round: true,
          range: [halfOfSegWidth + CONST.LEFT_RIGHT_PADDING, sankeyData.layout.width - halfOfSegWidth - CONST.LEFT_RIGHT_PADDING]
        })
      }}
      formatters={{ x: (value) => (stageLabels[value]) }}
      labels={{ x: sankeyData.layout.axisLabel }}
      dimensions={{ height: xAxisTopPosition }}
    />
  )
}
